/**
 * Billing Actions
 * NgRx actions for billing and subscription management
 */
import { createAction, props } from '@ngrx/store';
import {
  Subscription,
  UsageResponse,
  PricingPlan,
  CreateSubscriptionRequest,
  UpdateSubscriptionRequest,
  SubscriptionCreatedResponse,
  CancelSubscriptionResponse
} from '../models/billing.models';

// Load Pricing Plans
export const loadPlans = createAction('[Billing] Load Plans');

export const loadPlansSuccess = createAction(
  '[Billing] Load Plans Success',
  props<{ plans: PricingPlan[] }>()
);

export const loadPlansFailure = createAction(
  '[Billing] Load Plans Failure',
  props<{ error: string }>()
);

// Load Subscription
export const loadSubscription = createAction('[Billing] Load Subscription');

export const loadSubscriptionSuccess = createAction(
  '[Billing] Load Subscription Success',
  props<{ subscription: Subscription }>()
);

export const loadSubscriptionFailure = createAction(
  '[Billing] Load Subscription Failure',
  props<{ error: string }>()
);

// Load Usage
export const loadUsage = createAction('[Billing] Load Usage');

export const loadUsageSuccess = createAction(
  '[Billing] Load Usage Success',
  props<{ usage: UsageResponse }>()
);

export const loadUsageFailure = createAction(
  '[Billing] Load Usage Failure',
  props<{ error: string }>()
);

// Create Subscription
export const createSubscription = createAction(
  '[Billing] Create Subscription',
  props<{ request: CreateSubscriptionRequest }>()
);

export const createSubscriptionSuccess = createAction(
  '[Billing] Create Subscription Success',
  props<{ response: SubscriptionCreatedResponse }>()
);

export const createSubscriptionFailure = createAction(
  '[Billing] Create Subscription Failure',
  props<{ error: string }>()
);

// Update Subscription
export const updateSubscription = createAction(
  '[Billing] Update Subscription',
  props<{ request: UpdateSubscriptionRequest }>()
);

export const updateSubscriptionSuccess = createAction(
  '[Billing] Update Subscription Success',
  props<{ subscription: Subscription }>()
);

export const updateSubscriptionFailure = createAction(
  '[Billing] Update Subscription Failure',
  props<{ error: string }>()
);

// Cancel Subscription
export const cancelSubscription = createAction(
  '[Billing] Cancel Subscription',
  props<{ immediately: boolean }>()
);

export const cancelSubscriptionSuccess = createAction(
  '[Billing] Cancel Subscription Success',
  props<{ response: CancelSubscriptionResponse }>()
);

export const cancelSubscriptionFailure = createAction(
  '[Billing] Cancel Subscription Failure',
  props<{ error: string }>()
);

// Reactivate Subscription
export const reactivateSubscription = createAction('[Billing] Reactivate Subscription');

export const reactivateSubscriptionSuccess = createAction(
  '[Billing] Reactivate Subscription Success',
  props<{ subscription: Subscription }>()
);

export const reactivateSubscriptionFailure = createAction(
  '[Billing] Reactivate Subscription Failure',
  props<{ error: string }>()
);

// Redirect to Checkout
export const redirectToCheckout = createAction(
  '[Billing] Redirect to Checkout',
  props<{ stripePriceId: string; trialDays?: number }>()
);

export const redirectToCheckoutFailure = createAction(
  '[Billing] Redirect to Checkout Failure',
  props<{ error: string }>()
);

// Redirect to Customer Portal
export const redirectToCustomerPortal = createAction('[Billing] Redirect to Customer Portal');

export const redirectToCustomerPortalFailure = createAction(
  '[Billing] Redirect to Customer Portal Failure',
  props<{ error: string }>()
);

// Clear Error
export const clearError = createAction('[Billing] Clear Error');

